export const pendingMembershipExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{
		label: 'Community',
		render: m => m?.hub?.name || '',
	},
	{
		label: 'Sanstha',
		render: m => m?.sansthaId?.name || '',
	},
	{
		label: 'User Name',
		render: m => (m?.userId ? `${m.userId.firstName || ''} ${m.userId.lastName || ''}`.trim() : ''),
	},
	{
		label: 'Mobile',
		render: m => m?.userId?.mobile || '',
	},
	{
		label: 'Membership Type',
		render: m => m?.membershipType || '',
	},
	{
		label: 'Honorary Answer',
		render: m => m?.honoraryAnswer || '',
	},
	{
		label: 'Existing Member',
		render: m => (m?.existingMember === true || m?.existingMember === 'true' ? 'Yes' : 'No'),
	},
	{
		label: 'Amount',
		render: m => m?.amount ?? '',
	},
	{
		label: 'Payment Mode',
		render: m => m?.paymentMode || '',
	},
	{
		label: 'Payment Ref No',
		render: m => m?.paymentRef || '',
	},
	{
		label: 'Payment Date',
		render: m => (m?.paymentDate ? new Date(m.paymentDate).toLocaleDateString('en-IN') : ''),
	},
	{
		label: 'Status',
		render: m => m?.status || '',
	},
]
